import Marquee from "react-fast-marquee";

const ITEMS = ["ON-PREMISES", "MICROSOFT 365", "IDENTITY", "IT-SECURITY"];

export const BrandMarquee = () => {
  return (
    <div
      data-testid="brand-marquee"
      className="border-y border-zinc-200 bg-zinc-50/60 py-8 md:py-10"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-medium text-4xl md:text-6xl text-zinc-900 mx-8">
              {item}
            </span>
            <span className="w-3 h-3 rounded-full brand-gradient mx-8" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
